/**
 *
 * Section Step3 - Your details
 *
 */

/*
 * Data collected:
 *
 * senderFirstName
 * senderLastName
 * senderPhone
 * senderEmail
 * senderAddress1
 * senderAddress2
 * senderCity
 * senderCountry
 * senderBirthDate
 * senderId
 *
 */

import PropTypes from "prop-types";
import React, { useState } from "react";
import BackSvg from "../partials/BackSvg.jsx";

// Based on https://www.freecodecamp.org/news/how-to-validate-forms-in-react/
import { Input } from "../components/Input.jsx";
import { FormProvider, useForm } from "react-hook-form";
import {
  required_validation,
  email_validation,
} from "../utils/inputValidations";

function Step3(props) {
  /*
   * Open Privacy policy
   */
  const openPrivacyPolicy = (e) => {
    props.emitChangeSection("privacyPolicy", e);
  };

  /* Forms */
  const handleChange = (e) => {
    props.emitUpdateFormdata(e.target.name, e.target.value);
  };

  const methods = useForm();
  const onSubmit = methods.handleSubmit((data) => {
    props.emitChangeSection("step4");
  });

  return (
    <div className="step" id="step3">
      {/* Headline & Intro */}
      <div className="row">
        <div className="col col-10">
          <h1 className="headline">Your details</h1>
          <div className="progress bar2">&nbsp;</div>
        </div>
      </div>
      <div className="row">
        <div className="col col-8">
          <p className="intro">Your data is used for this process only stored only temporarily. See our <a onClick={openPrivacyPolicy} >privacy policy</a> for more info.</p>
        </div>
      </div>

      <FormProvider {...methods}>
        <form
          onSubmit={(e) => e.preventDefault()}
          noValidate
          className="container"
        >
          <div className="row">
            <div className="col-8">
              <Input
                label="First name *"
                type="text"
                name="senderFirstName"
                value={props.formData.senderFirstName}
                handleChange={(e) => handleChange(e)}
                placeholder="last name"
                validation={{ ...required_validation }}
              />
              <Input
                label="First name *"
                type="text"
                name="senderLastName"
                value={props.formData.senderLastName}
                handleChange={(e) => handleChange(e)}
                placeholder="last name"
                validation={{ ...required_validation }}
              />

              <Input
                label="Address"
                type="text"
                name="senderAddress1"
                value={props.formData.senderAddress1}
                handleChange={(e) => handleChange(e)}
                placeholder="line1"
                validation={{ ...required_validation }}
              />

              <Input
                type="text"
                name="senderAddress2"
                value={props.formData.senderAddress2}
                handleChange={(e) => handleChange(e)}
                placeholder="line1"
                validation={{ ...required_validation }}
              />

              <Input
                label="City"
                type="text"
                name="senderCity"
                value={props.formData.senderCity}
                handleChange={(e) => handleChange(e)}
                placeholder="city"
                validation={{ ...required_validation }}
              />

              <Input
                label="Country"
                type="text"
                name="senderCountry"
                value={props.formData.senderCountry}
                handleChange={(e) => handleChange(e)}
                placeholder="country"
                validation={{ ...required_validation }}
              />

              <Input
                label="Phone number *"
                type="number"
                pattern="[0-9]*"
                name="senderPhone"
                value={props.formData.senderPhone}
                handleChange={(e) => handleChange(e)}
                placeholder="phone number"
                validation={{ ...required_validation }}
              />

              <Input
                label="Email"
                type="text"
                name="senderEmail"
                value={props.formData.senderEmail}
                handleChange={(e) => handleChange(e)}
                placeholder="email@mail.com"
                validation={{ ...email_validation }}
              />
              <Input
                label="Date of Birth *"
                type="date"
                name="senderBirthDate"
                value={props.formData.senderBirthDate}
                handleChange={(e) => handleChange(e)}
                placeholder="dd-mm-yyyy"
                validation={{ ...required_validation }}
              />
              <Input
                label="Last four digits of your BSN *"
                type="text"
                name="senderId"
                value={props.formData.senderId}
                handleChange={(e) => handleChange(e)}
                placeholder="xxxx"
                maxlength="4"
                validation={{ ...required_validation }}
              />
            </div>
            {/*col*/}
          </div>
          {/*formRow*/}
        </form>
      </FormProvider>

      <div className="row">
        <div className="col flex-center">
          <div
            className="button buttonBack"
            onClick={(e) => props.emitChangeSection("step2", e)}
          >
            <BackSvg />
            back
          </div>
          <div className="button buttonOptMeOut" onClick={onSubmit}>
            OptMeOut
          </div>
        </div>
        {/*col*/}
      </div>
      {/*row*/}
    </div>
  );
}

Step3.propTypes = {
  formData: PropTypes.object,
  emitChangeSection: PropTypes.func,
  emitUpdateFormdata: PropTypes.func,
};

export default Step3;
